class TrainingDetailsPresenter {
  constructor(
    view,
    findObjectUseCase,
    saveObjectUseCase,
    updateObjectUseCase,
    saveFileUseCase
  ) {
    this.view = view;
    this.findObjectUseCase = findObjectUseCase;
    this.saveObjectUseCase = saveObjectUseCase;
    this.updateObjectUseCase = updateObjectUseCase;
    this.saveFileUseCase = saveFileUseCase;
    this.learn = null;
  }

  componentDidMount() {
    this.view.showProgress();
    Promise.resolve()
      .then(() => this.getAnnouncement())
      .then(() => this.view.hideProgress())
      .catch((error) => {
        this.view.hideProgress();
        this.view.showError(error);
      });
  }

  getAnnouncement() {
    this.learn = this.view.getAnnouncement();
    this.view.setAnnouncement(this.learn);
    if (!this.learn) {
      const id = this.view.getAnnouncementId();
      const query = {
        where: { id: id },
        include: ["all"],
      };
      return this.findObjectUseCase.execute("train", query).then(([learn]) => {
        this.learn = learn;
        this.view.setAnnouncement(this.learn);
      });
    }
  }

  onClickBack() {
    this.view.navigateBack();
  }
}

export default TrainingDetailsPresenter;
